import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayArrowFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 5.2C8 4.53726 8.72483 4.12949 9.29289 4.47487L18.5858 10.0749C19.1381 10.4083 19.1381 11.1917 18.5858 11.5251L9.29289 17.1251C8.72483 17.4705 8 17.0627 8 16.4V5.2Z",
		fill: "#323232"
	})
});
const ForwardRef = forwardRef(SvgPlayArrowFilled);
export default ForwardRef;
